import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ProcessingModalService } from 'src/app/_services/processing-modal.service';

@Component({
  selector: 'app-processing-modal',
  templateUrl: './processing-modal.component.html',
  styleUrls: ['./processing-modal.component.scss']
})
export class ProcessingModalComponent implements OnInit, OnDestroy {
  isProcessing: boolean = false;
  processingMessage: string = 'Processing data...';
  isCompleted: boolean = false;
  progress: number = 0;
  circumference: number = 2 * Math.PI * 36; // 2πr where r=36

  private processingSub: Subscription;
  private messageSub: Subscription;
  private completedSub: Subscription;
  private progressInterval: any;

  constructor(private processingModalService: ProcessingModalService) { }

  ngOnInit(): void {
    this.processingSub = this.processingModalService.isProcessing$.subscribe(
      (processing: boolean) => {
        this.isProcessing = processing;
        if (processing) {
          this.startProgress();
        } else {
          this.stopProgress();
        }
      }
    );

    this.messageSub = this.processingModalService.processingMessage$.subscribe(
      (message: string) => {
        this.processingMessage = message;
      }
    );

    this.completedSub = this.processingModalService.isCompleted$.subscribe(
      (completed: boolean) => {
        this.isCompleted = completed;
        if (completed) {
          this.progress = 100;
          this.stopProgress();
        }
      }
    );
  }

  private startProgress(): void {
    this.progress = 0;
    this.progressInterval = setInterval(() => {
      if (this.progress < 90 && !this.isCompleted) {
        this.progress += Math.random() * 10;
      }
    }, 200);
  }

  private stopProgress(): void {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
      this.progressInterval = null;
    }
  }

  ngOnDestroy(): void {
    if (this.processingSub) {
      this.processingSub.unsubscribe();
    }
    if (this.messageSub) {
      this.messageSub.unsubscribe();
    }
    if (this.completedSub) {
      this.completedSub.unsubscribe();
    }
    this.stopProgress();
  }
}
